export enum EPhotoEditorConsumer {
  PROFILE_SIDE_INFO = 'PROFILE_SIDE_INFO',
  PROFILE_MEDIA_IMAGE = 'PROFILE_MEDIA_IMAGE',
  PROFILE_MEDIA_EDITOR = 'PROFILE_MEDIA_EDITOR',
}
